import Chip from "@material-ui/core/Chip";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    display: "inline-block",
    margin: -theme.spacing(0.5),
  },
  chip: {
    margin: theme.spacing(0.5),
  },
  chipAllBranch: {
    margin: theme.spacing(0.5),
    backgroundColor: "rgb(130, 193, 77)",
  },
});
class MultiSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      arrBranch: [],
    };
  }
  componentDidMount() {
    if (this.props.value) {
      var value = JSON.parse(this.props.value);
      var arrBranch = this.state.arrBranch;
      for (var i = 0; i < value.length; i++) {
        let branch = this.props.listBranch.filter(
          (ele) => ele.branchCode === value[i]
        );
        if (branch.length) {
          arrBranch.push({
            label: branch[0].branchName,
            value: branch[0].branchCode,
          });
        }
      }
      this.setState(arrBranch);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value) {
      var value = JSON.parse(nextProps.value);
      let newArr = [];
      for (var i = 0; i < value.length; i++) {
        let branch = this.props.listBranch.filter(
          (ele) => ele.branchCode === value[i]
        );
        if (branch.length) {
          newArr.push({
            label: branch[0].branchName,
            value: branch[0].branchCode,
          });
        }
      }
      this.setState({ arrBranch: newArr });
    }
  }
  render() {
    const { classes, forAll, t } = this.props;
    const { arrBranch = [] } = this.state;
    return (
      <div className={classes.root}>
        {forAll === 1 && (
          <Chip
            label={t("voucher_listvoucher_cardvoucher_all_branch")}
            className={classes.chipAllBranch}
            color="primary"
          />
        )}
        {forAll === 0 &&
          arrBranch.map((item, index) => {
            return (
              <Chip
                label={item.label}
                className={classes.chip}
                color="default"
                key={index}
              />
            );
          })}
      </div>
    );
  }
}

MultiSelect.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  listBranch: state.serviceBranch.listBranch,
});

const mapDispatch = (dispatch) => ({});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(MultiSelect)
  )
);
